// action
import {
    SAVE_ROLE_MODULE_MAPPING,
    SAVE_ROLE_MODULE_MAPPING_FAIL,
    SAVE_ROLE_MODULE_MAPPING_SUCCESS,
    SAVE_ROLE_MODULE_MAPPING_RESET
} from '../action/saveRoleModuleMappingAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_ROLE_MODULE_MAPPING:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_ROLE_MODULE_MAPPING_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_ROLE_MODULE_MAPPING_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_ROLE_MODULE_MAPPING_RESET:
            return initialState
        default:
            return state
    }
}